import LogoBrandIcon from './LogoBrandIcon';

export default LogoBrandIcon;